import { put, takeLatest } from 'redux-saga/effects'
import { finishWebAuthnRegistration as finishRegistration } from '../api/finishWebAuthnRegistration'
import {
  finishWebAuthnRegistrationSucceeded,
  finishWebAuthnRegistrationFailed
} from '../../actions/setupMFAWebAuthn'
import { addMfaMechanismSucceeded } from '../../actions/mfaSettings'
import { FINISH_WEB_AUTHN_REGISTRATION } from '../../constants/action.types'
import { WEB_AUTHN } from '../../constants/mfa'
import executeSaga from './helpers/executeSaga'

export function* finishWebAuthnRegistration({ request }, action) {
  const { requestId, credential } = action.payload

  yield executeSaga(
    request,
    { requestId, credential },
    () => [
      put(finishWebAuthnRegistrationSucceeded()),
      put(addMfaMechanismSucceeded({ mfaMechanism: WEB_AUTHN }))
    ],
    error => put(finishWebAuthnRegistrationFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: finishRegistration }) {
  yield takeLatest(FINISH_WEB_AUTHN_REGISTRATION, finishWebAuthnRegistration, {
    request
  })
}
